import React, { useState, useEffect, useRef } from "react";
import footbal from "../../../assets/customerAssets/football.png";
import { Box, Button, IconButton, ImageListItem } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import cameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import { supportedImageFileTypes } from "../../../helper/commonFunctions";
import { dressImageAccept } from "../../../utils/competitionEventMedia";
import { toast, ToastContainer } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import { resizeImageFileToCover } from "../../../utils/advertisementBannerSpec";

const BannerImage = ({
  formik,
  edited,
  validateFile,
  autoFit,
  fieldName = "image",
  accept,
}) => {
  //   const [img, setImg] = useState(null);
  // const [imgPreview, setImgPreview] = useState(() =>
  //   edited
  //     ? formik.values.image
  //     : formik.values.image
  //     ? URL.createObjectURL(formik.values.image)
  //     : null
  // );
  const [imgPreview, setImgPreview] = useState(null);
  const imageInputRef = useRef(null);

  const imageValue = formik.values[fieldName];

  useEffect(() => {
    if (typeof imageValue === "string" && imageValue) {
      setImgPreview(imageValue);
    } else if (imageValue instanceof File) {
      const url = URL.createObjectURL(imageValue);
      setImgPreview(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setImgPreview(null);
    }
  }, [imageValue]);

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const fileType = file.type.split("/")[1];
    const fileExt = file.name.split(".").pop().toLowerCase();

    if (
      supportedImageFileTypes.includes(file.type) === false &&
      supportedImageFileTypes.includes(fileExt) === false
    ) {
      toast.error("Please select a valid image file");
      return;
    }

    let nextFile = file;
    if (autoFit?.width && autoFit?.height) {
      try {
        nextFile = await resizeImageFileToCover(
          file,
          autoFit.width,
          autoFit.height
        );
        toast.success("Banner resized to fit the site layout.");
      } catch {
        toast.error("Could not resize image. Try another file.");
        e.target.value = "";
        return;
      }
    } else if (validateFile) {
      const dimensionError = await validateFile(file);
      if (dimensionError) {
        toast.error(dimensionError);
        e.target.value = "";
        return;
      }
    }

    formik.setFieldValue(fieldName, nextFile);
  };

  // "";

  return (
    <>
      <ToastContainer />
      <Box className="preview-wrapper">
        <input
          type="file"
          name={fieldName}
          accept={accept || dressImageAccept}
          onChange={handleChange}
          style={{ display: "none" }}
          ref={imageInputRef}
        />
        <Box className="preview" sx={{ padding: "0" }}>
          {imgPreview ? (
            <img
              src={imgPreview}
              alt="football"
              className={autoFit ? "img_fluid img_fluid_cover" : "img_fluid"}
              style={
                imgPreview
                  ? { objectFit: autoFit ? "cover" : "contain" }
                  : { opacity: "24%" }
              }
            />
          ) : (
            <Button
              className="upload_button"
              onClick={() =>
                imageInputRef.current && imageInputRef.current.click()
              }
            >
              + Upload
            </Button>
          )}
        </Box>
        {imgPreview && (
          <IconButton
            onClick={() => {
              setImgPreview("");
              formik.setFieldValue(fieldName, "");
            }}
            className="clear-Icon"
          >
            <ClearIcon
              sx={{
                fontSize: "30px",
              }}
              className="clear-preview-img"
            />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default BannerImage;
